module.exports = __webpack_public_path__ + "img/logo-company.9829697b.png";